import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReachService {

  private reachesSource = new BehaviorSubject<Reach[]>([]);
  currentReaches = this.reachesSource.asObservable();

  private stationsSource = new BehaviorSubject<DssStation[]>([]);
  currentStations = this.stationsSource.asObservable();

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private http: HttpClient
  ) { }

  getReaches() {
    this.http.get<Reach[]>(`${this.baseUrl}api/reach`).subscribe(response => {
      if (response) {
        this.changeReach(response);
      } else {
        this.changeReach(null);
      }
    })
  }

  getStations() {
    this.http.get<DssStation[]>(`${this.baseUrl}api/reach/stations`).subscribe(response => {
      if (response) {
        this.changeStations(response);
      } else {
        this.changeReach(null);
      }
    })
  }

  changeReach(reach) {
    this.reachesSource.next(reach);
  }
  changeStations(stations) {
    this.stationsSource.next(stations);
  }

}

export interface Reach {
  ReachNumber: number;
  ReachName: string;
  ReachDescription: string;
  DisplayOrder: number;
  ReachStartName: string;
  ReachEndName: string;
  ReachInCalculation: boolean;
}

export interface DssStation {
  dssStationId: number;
  dssStationNumber: string;
  dssStationName: string;
  stationNumber: string;
  stationName: string;
  abbreviatedStationName: string;
  latitude: number;
  longitude: number;
  nextDownStationId: number;
  travelTime: number;
  dssScope: number;
}
